import colors from '@styles/colors';

export default function BoxIcon({ type }: { type: string }) {
    const settings = {
        'mini': { text: 'Mi', color: colors.PINK_DARK, },
        'small': { text: 'Sm', color: colors.PINK, },
        'medium': { text: 'Me', color: colors.BLUE, },
        'large': { text: 'La', color: colors.GREEN_BRIGHT, },
        'family': { text: 'Fa', color: colors.ORANGE, },
        'default': { text: 'Un', color: colors.BLACK_LIGHT_65, },
    };

    const properties = (settings as any)[type] || (settings as any)['default'];

    return (
        <span className="box-icon" style={{ backgroundColor: properties.color }}>{properties.text}</span>
    );
}
